import { getQueryValue, handleLogout } from "../../helpers/utils";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Logout = () => {
  const location = useLocation();
  const appRef = getQueryValue(location.search, "appref");

  useEffect(() => {
    if (appRef) {
      handleLogout(appRef);
    } else {
      handleLogout();
    }
    // eslint-disable-next-line
  }, []);

  return <div>Loading...</div>;
};

export default Logout;
